import React from "react";

// Creating the context object and passing the default values.
const commonContext = React.createContext({
  loader: false,
  setLoader: () => {},
});

export default commonContext;
